import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'TheMain',
  setup(__props) {

const EntryPoint = defineAsyncComponent(() => import('frontend/EntryPoint.vue'))
const PasswordResetEntryPoint = defineAsyncComponent(() => import('frontend/PasswordResetEntryPoint.vue'))
const PasswordUpdateEntryPoint = defineAsyncComponent(() => import('frontend/PasswordUpdateEntryPoint.vue'))

const route = useRoute()
const isPasswordResetRoute = computed<boolean>(() => {
  return route.path.includes('reset-password')
})
const isPasswordUpdateRoute = computed<boolean>(() => {
  return route.path.includes('update-password')
})

return (_ctx: any,_cache: any) => {
  return (isPasswordResetRoute.value)
    ? (_openBlock(), _createBlock(_unref(PasswordResetEntryPoint), { key: 0 }))
    : (isPasswordUpdateRoute.value)
      ? (_openBlock(), _createBlock(_unref(PasswordUpdateEntryPoint), { key: 1 }))
      : (_openBlock(), _createBlock(_unref(EntryPoint), { key: 2 }))
}
}

})